import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {connect} from "react-redux";
import {userActions} from "../../../actions/user.actions";
import UserTable from "./_components/UserTable";
import UserForm from "./_forms/UserForm";
import {modalActions} from "../../../actions/modal.actions";
import {formType} from "../../../constants/form-type.constants";

class UserPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(userActions.getUserList());
    }

    openModalCreateUser = () => {
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_device-group'),
            component: <UserForm type={formType.CREATE} submit={this.handleSubmitCreateForm}/>,
        };

        dispatch(userActions.getUserById(0));
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}));
    };

    handleSubmitCreateForm = (dataForm) => {
        const { dispatch } = this.props;
        dispatch(userActions.createUser(dataForm));
    };

    render() {
        const { t, userList } = this.props;

        const breadcrumb = [
            { value: 'users', path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('users') }</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <button
                                className="btn btn-success float-right"
                                onClick={this.openModalCreateUser}
                            > <i className="fas fa-plus"> </i> &nbsp; {t("create")}
                            </button>
                        </div>
                    </div>

                    <div className="card-body">
                        <UserTable list={userList} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { userList } = state.userReducer;
    return {
        userList
    }
};
export default withNamespaces()(connect(mapStateToProps)(UserPage));
